import React from 'react';
import { Button } from 'antd';
import type { ButtonProps } from 'antd';

export type AppButtonProps = ButtonProps;

const AppButton = React.forwardRef<HTMLButtonElement, AppButtonProps>((props, ref) => {
  return <Button ref={ref} {...props} />;
});

AppButton.displayName = 'AppButton';

export default AppButton;
